import { API_BASE_URL } from '../../constants';

export function makeParcelLatLngSearchAPIUrl({ lat, lng }) {
    return `${API_BASE_URL}/pwd/search?x=${lng}&y=${lat}`;
}

export const latLngSearchPopUpID = 'lat-lng-search-content-id';

export const latLngSearchPopUpClassName = 'lat-lng-search-popup';
